<template>
  <div class="page-table">
    <div class="page-search">
      <a-form :form="form">
        <a-form-item>
          <UEditor
            :max="2000"
            @maxlength="getContentLength"
            v-decorator="[
              'ny',
              {
                rules: [{validator: valLength,}]
              }]"
          />
        </a-form-item>
      </a-form>
      <a-row class="search-btns" style="text-align:center;margin-top:20px">
        <a-button @click="handleSubmit" type="primary" html-type="submit">保存编辑</a-button>
      </a-row>
    </div>
  </div>
</template>

<script>
import UEditor from '@/components/Editor/UEditor'
export default {
  name: 'Notice',
  components: {
    UEditor
  },
  data () {
    return {
      contentMax: 0,
      form: this.$form.createForm(this),
      // Editorval: '',
      Editorvalid: ''
    }
  },
  mounted () {
    this.getnotice()
  },
  methods: {
    getnotice () {
      this.$axios.post('/api/bxjl/getBxxz.do').then(res => {
        this.Editorvalid = res.data.data.id || ''
        this.$nextTick(() => {
          let fields = this.form.getFieldsValue()
          for (var key in fields) {
            fields[key] = res.data.data[key]
          }
          this.form.setFieldsValue(fields)
        })
      })
    },
    // 获取富文本长度
    getContentLength (max) {
      this.contentMax = max
    },
    valLength (rule, value, callback) {
      let _this = this
      setTimeout(function () {
        if (_this.contentMax > 2000) {
          callback(new Error('正文内容不多于2000个字符！'))
        } else {
          callback()
        }
      }, 100)
    },
    // 新增、编辑
    handleSubmit () {
      this.form.validateFields((err, values) => {
        if (!err) {
          // 处理编辑时添加ID字段
          if (this.Editorvalid && this.Editorvalid !== '') {
            values.id = this.Editorvalid
          }
          // values.type = '0' // 0-前端 1-后端
          // 接口请求
          this.submitAjax(values)
        }
      })
    },
    // 新增、编辑请求
    submitAjax (params) {
      this.$axios.post('/api/xtgl/bxxz.do', params).then(res => {
        this.$message.success(`${params.id ? ' 编辑' : '新增'}成功！`)
        this.visible = false
        // this.fetchList(this.getFetchParams({ pageNum: 1 }))
      })
    },
    /**
     * 获取请求列表参数
     * @param { Object } customParam 自定义处理
     * @return { Object } 请求列表参数
     */
    getFetchParams (customParam) {
      const { pageNum, isRemove } = customParam || {}
      let params = {
        // ...this.searchForm.getFieldsValue(),
        // ...this.PAGINATION,
        ...customParam
      }
      if (pageNum && params.pageNum) {
        params.pageNum = pageNum
      } else {
        params.pageNum = 1
        params.pageSize = 10
      }
      if (isRemove && params.pageNum && this.dataSource.length % 10 === 1) {
        params.pageNum = params.pageNum > 2 ? params.pageNum - 1 : 1
      }
      return params
    }
  }
}
</script>
<style>
.ant-form-item-control {
  line-height: inherit;
}
.ant-layout-content .page-search {
  border-bottom: none;
}
</style>
